import React, { createContext, useContext, useState } from 'react';

interface UserState {
  hasCompletedOnboarding: boolean;
  hasValidSubscription: boolean;
  teamEnabled: boolean;
}

interface UserContextType extends UserState {
  completeOnboarding: () => void;
  setSubscriptionStatus: (status: boolean) => void;
  setTeamStatus: (status: boolean) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<UserState>({
    // Set all states to true by default for development
    hasCompletedOnboarding: true,
    hasValidSubscription: true,
    teamEnabled: true,
  });

  const completeOnboarding = () => {
    setState(prev => ({ ...prev, hasCompletedOnboarding: true }));
  };

  const setSubscriptionStatus = (status: boolean) => {
    setState(prev => ({ ...prev, hasValidSubscription: status }));
  };

  const setTeamStatus = (status: boolean) => {
    setState(prev => ({ ...prev, teamEnabled: status }));
  };

  return (
    <UserContext.Provider value={{
      ...state,
      completeOnboarding,
      setSubscriptionStatus,
      setTeamStatus,
    }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};